import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { SupplierCertDto } from '@api/models/suppliers/SupplierCertDto';
import { supplierEmployeeService } from '@api/services/services';

export interface SupplierEmployeeDocumentListFilter extends ListFilter {
  ignoreExpired?: boolean;
}

export type SupplierEmployeeDocumentListState = ListType<SupplierCertDto, SupplierEmployeeDocumentListFilter>;

const initialState: SupplierEmployeeDocumentListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    ignoreExpired: true,
    sortBy: 'created',
    sortDesc: true,
  },
};

export const supplierEmployeeDocumentListSlice = listSlice({
  name: 'supplierEmployeeDocumentList',
  initialState,
});

export const selectSupplierEmployeeDocumentList = (state: RootState) => state.supplierEmployeeDocumentList;
export const supplierEmployeeDocumentListActions = supplierEmployeeDocumentListSlice.actions;

export const getSupplierEmployeeDocumentList = (employeeId: string, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectSupplierEmployeeDocumentList(storeState);

  const handleGetData = (size: number) => {
    return supplierEmployeeService.getCertificates(
      employeeId,
      {
        page: data.query.page,
        size: size,
        sort: getListSort(data),
        ignoreExpired: data.query.ignoreExpired,
      },
      { cancelToken: cancelToken as any }
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: supplierEmployeeDocumentListActions,
    getData: handleGetData,
  });
};
